import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";
import { CronogramaSGQLista } from "../../models/cronogramaSGQ_lista";
import { IGetAllCronogramaSGQUseCase } from "../../../presentation/useCases/read/get_all_qualidade_cronogramasgq_use_case";
import { CronogramaSGQFilter } from "../../models/cronogramasgq_filter";


// GetAllQualidadeCronogramaSGQServicoUseCase


export class GetAllQualidadeCronogramaSGQServicoUseCase
  extends BasePaginatedUseCase<CronogramaSGQLista>
  implements IGetAllCronogramaSGQUseCase {
  constructor(private readonly repository: IQualidadeRepository) {
    super();
  }

  async getAllListagemCronogramaSGQ(
    filter: CronogramaSGQFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    
    const response = await this.repository
      .getAllListagemCronogramaSGQ(
        filter,
        page,
        rowsPerPage,
      );
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
